import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import * as actionTourProperty from '../../../../actions/tourPropertyAction';
// import * as PropertyComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import * as ANT from 'antd';
import DEFINE, { PATHS, ORDER, FEATURE_FLAGS, TRANSLATE_LANGUAGE } from "../../../../constants/Define";
import { FlagIcons } from '../../common/component/TranslateButton';
import { toArray } from 'lodash';
import EllipsisText from '../../common/component/EllipsisText';
import Span from '../../common/component/Span';
import { find } from 'lodash';
import FontIcon, { SolidIcons } from '../../common/component/FontIcon';
import * as PropertyComponent from './component/CommonComponent';

let permisionActions = [];
class Properties extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.PropertiesModel.titleTable, ['action'], ['id']),
        modelProperty: Model.PropertiesModel.titleTable,
        componentTable: {
            name: {
                sorter: (i, k) => i.name.length - k.length,
                key: 'name',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            type: {
                key: 'types',
                render: (types, record) => (
                    <Fragment>
                        {(types || []).map(typeProd => {
                            const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === typeProd)
                            return typeKey && <ANT.Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                                <FontIcon key={typeProd} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                            </Span></ANT.Tooltip>
                        })}
                    </Fragment>
                ),
                filters: [
                    { value: ORDER.TYPES['VOUCHER'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VOUCHER'].key}`) },
                    { value: ORDER.TYPES['TOUR'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['TOUR'].key}`) },
                    { value: ORDER.TYPES['VINWONDER'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VINWONDER'].key}`) },
                ],
                filterMultiple: true,
            },
            email: {
                key: 'email',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            phone: {
                key: 'phone',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            address: {
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            translations: {
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
                render: (text, record) => <FlagIcons languages={record.translations} />,
                width: 120,
            },
            action: {
                align: 'center',
                width: 100,
                render: (text, record) => <PropertyComponent.EditComponent item={record} permisionActions={permisionActions}
                onDeleteProperty={this.props.onDeleteProperty} />,
            }
        },
        properties: [],
        pageSize: this.props.tourProperties.data.pageSize,
        pageIndex: this.props.tourProperties.data.pageIndex,
        totalCount: this.props.tourProperties.data.totalCount,
        totalPage: this.props.tourProperties.data.totalPage,
        isFetching: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PROPERTY);
        this.setState({
            pageSize: this.props.tourProperties.data.pageSize,
            pageIndex: this.props.tourProperties.data.pageIndex,
            totalCount: this.props.tourProperties.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.tourProperties.data.totalCount) / parseInt(this.props.tourProperties.data.pageSize))
        })
        this.props.onListProperty({ pageSize: this.props.tourProperties.data.pageSize, pageIndex: this.props.tourProperties.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.tourProperties.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.tourProperties.data !== prevProps.tourProperties.data) {
            this.setState({
                properties: this.props.tourProperties.data.result,
                pageSize: this.props.tourProperties.data.pageSize,
                pageIndex: this.props.tourProperties.data.pageIndex,
                totalCount: this.props.tourProperties.data.totalCount,
                totalPage: this.props.tourProperties.data.totalCount / this.props.tourProperties.data.pageSize,
            })
        }
    }

    onChangeLanguage = (language) => {
        this.props.onListProperty({ pageSize: this.props.tourProperties.data.pageSize, pageIndex: this.props.tourProperties.data.pageIndex });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListProperty(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, properties, modelProperty, isFetching, totalCount, componentTable, pageIndex, pageSize } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath="properties"
                        titleHeader={t('navigation.properties')}
                        componentRight={
                            <Fragment> {
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={PATHS.TOUR_PROPERTIES.CREATE.path}
                                    className='btn btn-primary'> + {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="property-list"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(properties, modelProperty)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'property'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, current: pageIndex, pageSize }}
                        componentTableList={{
                            // right: <Fragment> {
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <Link to="/properties/action"
                            //         className='btn btn-primary'> + {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                        classChildren="p-0" classParent="m-0"
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        tourProperties: state.tourPropertyReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListProperty: (filters) => {
            dispatch(actionTourProperty.dataPropertyAction(filters))
        },
        onDeleteProperty: (id) => {
            dispatch(actionTourProperty.deletePropertyAction(id))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Properties));
